import { normalizeOrganizationTreeResponse } from 'src/stores/organization/normalizeTreeNodes';

import { SharedQueryTreeNode } from 'src/models/organization';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheSharedQueriesForTheUserQueryCallBack extends Callback<Array<SharedQueryTreeNode>> {
	public constructor(
		private readonly setSharedQueryTreeHierarchy: (tree: Array<SharedQueryTreeNode>) => void,
		private readonly rootNodeId = 'tree_sharedQueries'
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: unknown): void => {
		this.setSharedQueryTreeHierarchy(normalizeOrganizationTreeResponse(successResponse, this.rootNodeId));
	};
}
